<!-- Presentation Name -->
<stretchy-input
  class="presentation-name"
  [(value)]="templateEditorFactory.presentation.name"
  ariaLabel="Edit presentation name"
/>
<div class="tw-flex tw-flex-row tw-items-center">
  <div class="btn-group" dropdown>
    <button id="moreSettingsButton" type="button"
      class="dropdown-toggle tw-flex tw-items-center tw-justify-center tw-ml-2 tw-rounded-full tw-p-2 tw-border tw-border-solid tw-border-gray-200 tw-bg-transparent focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
      [matMenuTriggerFor]="moreMenu"
      aria-label="Presentation options">
      <mat-icon svgIcon="more-vertical" class="tw-rotate-90" />
    </button>
    <mat-menu
      #moreMenu="matMenu"
      id="moreMenu"
      role="menu"
      tabindex="-1"
      aria-labelledby="moreSettingsButton">
      <button mat-menu-item
        role="menuitem"
        tabindex="-1"
        id="changeTemplateButton"
        uiSref="apps.editor.add">New Presentation</button>
      <button mat-menu-item
        role="menuitem"
        tabindex="-1"
        id="copyPresentationButton"
        [disabled]="!templateEditorFactory.presentation.id"
        [attr.aria-disabled]="!templateEditorFactory.presentation.id"
        (click)="templateEditorFactory.copyPresentation()">Duplicate</button>
      <button mat-menu-item
        role="menuitem"
        tabindex="-1"
        *requireRole="'!ap'"
        id="sharePresentationButton"
        [disabled]="!templateEditorFactory.presentation.id"
        [attr.aria-disabled]="!templateEditorFactory.presentation.id"
        (click)="openSettings()">Save Presentation As Template</button>
      <button
        mat-menu-item
        role="menuitem"
        tabindex="-1"
        id="deleteButton"
        [disabled]="!templateEditorFactory.presentation.id"
        [attr.aria-disabled]="!templateEditorFactory.presentation.id"
        (click)="confirmDelete()">Delete</button>
    </mat-menu>
  </div>
  <status-badge class="tw-ml-[16px]" [status]="templateEditorFactory.presentation.revisionStatusName" [animate]="true"></status-badge>
</div>
<div class="flex-row ml-auto hidden-xs">
  <div id="autoSavingDesktop" class="tw-flex tw-items-center tw-justify-center">
    <span class="tw-block tw-h-[20px]" [shown]="!templateEditorFactory.savingPresentation && templateEditorFactory.isUnsaved()">
      <ng-container *ngTemplateOutlet="changeState; context: { icon: 'alert-circle', tooltip: 'Unsaved changes' }"></ng-container>
    </span>
    <span class="tw-block tw-h-[20px]" [shown]="!templateEditorFactory.savingPresentation && !templateEditorFactory.isUnsaved()">
      <ng-container *ngTemplateOutlet="changeState; context: { icon: 'circle-check', tooltip: getSavedTooltipText() }"></ng-container>
    </span>
    <span class="tw-block tw-h-[20px]" [shown]="templateEditorFactory.savingPresentation">
      <ng-container *ngTemplateOutlet="changeState; context: { icon: 'refresh', tooltip: 'Saving changes...' }"></ng-container>
    </span>
  </div>
  @if (templateEditorFactory.hasOnlyContentEditorRole()) {
    <button
      mat-flat-button
      id="sendForReviewButton"
      color="primary"
      (click)="templateEditorFactory.openReviewRequest()"
      [class.look-disabled]="!isPublicationApprovalAvailable"
      [disabled]="templateEditorFactory.presentation.revisionStatus === 0">
      Send for Review
      @if (!isPublicationApprovalAvailable) {
        <mat-icon class="small" svgIcon="requires-upgrade"></mat-icon>
      }
    </button>
  } @else if (templateEditorFactory.hasContentPublisherRole() || templateEditorFactory.hasTeacherRole()) {
    <!-- Pending review status -->
    @if (templateEditorFactory.hasContentPublisherRole() && templateEditorFactory.presentation.revisionStatus === 2) {
      <button mat-stroked-button id="requestChangesButton" class="tw-mr-[8px]" (click)="templateEditorFactory.openRequestChanges()">Request Changes</button>
      @if (!isPublicationApprovalAvailable) {
        <mat-icon class="small" svgIcon="requires-upgrade"></mat-icon>
      }
    }
    <button tabindex="0" id="publishButtonDesktop" class="btn btn-primary btn-fixed-width"
      [disabled]="templateEditorFactory.isPublishDisabled()"
      (click)="templateEditorFactory.publish()">
      Publish
    </button>
  }
</div>

<ng-template #changeState let-icon="icon" let-tooltip="tooltip">
  <mat-icon
    class="tw-mr-[22px] medium"
    [ngClass]="icon"
    [svgIcon]="icon"
    [matTooltip]="tooltip"
    matTooltipClass="menu-tooltip tw-max-w-[200px]"
    [attr.aria-label]="tooltip"
    tabindex="0"
    matTooltipPosition="below" />
</ng-template>
